/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import { store } from '../store/store';
import { routes } from './routes';
import * as roles from '@/utils/user-roles';

Vue.use(Router);

const router = new Router({
  base: process.env.VUE_APP_BASEPATH,
  mode: 'history',
  routes,
});

const redirectToProperRoute = userRoles => {
  if (
    userRoles.includes(roles.ROLE_ROOT)
  ) {
    router.push({ path: '/streams/control' });
  } else if (userRoles.includes(roles.ROLE_STREAM_MANAGER)) {
    router.push({ path: '/streams/changelog' });
  } else if (userRoles.includes(roles.ROLE_VOTE_MANAGER)) {
    router.push({ path: '/sessions/list/1' });
  } else if (userRoles.includes(roles.ROLE_VOTE_VIEWER)) {
    router.push({ path: '/vote/hello' });
  } else if (
    userRoles.includes(roles.ROLE_DOCUMENT_MANAGER) ||
    userRoles.includes(roles.ROLE_DOCUMENT_VIEWER)
  ) {
    router.push({ path: '/documents/list/', params: { page: 1 } });
  } else if (userRoles.includes(roles.ROLE_NOTIFICATION_MANAGER)) {
    router.push({ path: '/users/notifications-list/', params: { page: 1 } });
  } else if (userRoles.includes(roles.ROLE_USER_MANAGER)) {
    router.push({ path: '/users/list/', params: { page: 1 } });
  } else if (userRoles.includes(roles.ROLE_GROUP_MANAGER)) {
    router.push({ path: '/users/list/', params: { page: 1 } });
  } else if (userRoles.includes(roles.ROLE_VOD_MANAGER)) {
    router.push({ path: '/vod/browse-videos' });
  } else {
    router.push({ path: '/profile' });
  }
};

router.beforeEach((to, from, next) => {
  const { expireDate, userRoles, isLogged, root, shouldResetPassword } = store.state.auth;
  // routes without roles are accessible to everyone, no additional chain required

  if (!isLogged && to.name !== 'login' && to.name !=='projector') {
    return next('/login');
  } else {

    if (shouldResetPassword && to.name !== 'profile') {
      return next('/profile');
    }

    if (!to.meta.hasOwnProperty('roles')) {
      return next();
    }

    // Remove token if expired and redirect to login
    if (Date.now() > expireDate) {
      store.dispatch('auth/destroySession');
      return next({ name: 'login' });
    }

    // routes without roles are accessible to everyone, no additional chain required
    if (!to.meta.hasOwnProperty('roles')) {
      return next();
    }

    if (root) {
      return next();
    }

    // Check if user has access to specific route
    if (!to.meta.roles.some(role => userRoles.includes(role))) {
      return next({ name: 'access-denied' });
    }

    else {
      next();
    }
  }
});

export { router, redirectToProperRoute };
